import axios from "axios";
import { BASE_URL } from "../api/config";
import type { TenantPalette } from "@/themes/palette/tokens";

export interface ITenantTheme {
  palette: TenantPalette;
  // URLs assinadas do S3, válidas por 1h a partir da resposta.
  logoLightUrl: string | null;
  logoDarkUrl: string | null;
  updatedIn: string;
}

// Rota pública no backend (o tema vem da empresa do subdomínio). Não usa o
// `api` de propósito: o interceptor dele mostra toast em qualquer erro, e aqui
// uma falha só significa ficar no tema padrão.
export async function getTenantTheme() {
  const { data } = await axios.get<{ theme: ITenantTheme | null }>("/settings/theme", {
    baseURL: BASE_URL,
    withCredentials: true,
  });
  return data.theme;
}
